import Header from '@/components/Header';
import Dictionary from '@/components/Dictionary';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const DictionaryPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="Legal Dictionary | Freeman & Crown Law"
        description="Browse clear, concise definitions of legal terms in our legal dictionary."
        image={'/lovable-uploads/05910b5a-16d6-43be-a86c-ee19a8a35c77.png'}
        url={window.location.origin + '/dictionary'}
        type="website"
      />
      <Dictionary />
      <Footer />
    </div>
  );
};

export default DictionaryPage;